import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { httpinstance,httpinstancefile } from "../../../axios/api"


export const getsubscriptiontemplate= createAsyncThunk('getsubscriptiontemplate', async (queryParams)=>{
    try{
        const url = `admin/template${queryParams}`
        const response = await httpinstance.get(url)
        return response
    }catch (err){
        return err.response
    }
})

const initialState = {
    data:{},
    loading:false,
}

const subscriptionTemplateManagementSlice = createSlice({
    name : 'subscriptionTemplateManagement',
    initialState,
})
export default subscriptionTemplateManagementSlice.reducer